export const APP_FEATURES = {
  ADD_ONS: "addOns",
  INTEGRATIONS: "integrations",
  CLIENTS: "clients",
} as const;

export type AppFeatureKey = (typeof APP_FEATURES)[keyof typeof APP_FEATURES];

export const APP_FEATURE_LABELS: Record<AppFeatureKey, string> = {
  [APP_FEATURES.ADD_ONS]: "Add-ons",
  [APP_FEATURES.INTEGRATIONS]: "Integrations",
  [APP_FEATURES.CLIENTS]: "Clients",
};

export const APP_FEATURE_REMOTE_CONFIG_KEYS: Record<AppFeatureKey, string> = {
  [APP_FEATURES.ADD_ONS]: "feat_app_add_ons_enabled",
  [APP_FEATURES.INTEGRATIONS]: "feat_app_integrations_enabled",
  [APP_FEATURES.CLIENTS]: "feat_app_clients_enabled",
};

export const DEFAULT_APP_FEATURE_ACCESS: Record<AppFeatureKey, boolean> = {
  [APP_FEATURES.ADD_ONS]: true,
  [APP_FEATURES.INTEGRATIONS]: true,
  [APP_FEATURES.CLIENTS]: true,
};

